import updateFragment from "@groq/fragments/update";

const updateQuery = `*[_type == "update"]
  ${updateFragment}
`;

export default updateQuery;
